<template>
    <div class="test-result-content">
        <div class="title">{{ testResult.platform }}</div>
        <div class="subtitle test-result-content__subtitle">
            <test-result :result="testResult.result"/>
            {{ testResult.result }}
        </div>
        <table class="table">
            <tbody>
                <tr>
                    <th>JIRA task</th>
                    <td>
                        <edit-field :value="testResult.issue_url" :on-update="onIssueUrlUpdate">
                            <template v-slot:default="{ value }">
                                <a :href="value" target="_blank">{{ value }}</a>
                            </template>
                        </edit-field>
                    </td>
                </tr>
                <tr v-if="testResult.combinations"><th>Combinations</th><td>{{ testResult.combinations }}</td></tr>
                <tr><th>Products with targets</th>
                    <td>
                      <div>
                        <div
                            v-for="target_product in generateProductsTargetsArray(testResult.products_targets)"
                            :key="target_product"
                        >
                          {{ target_product }}
                        </div>
                      </div>
                    </td>
                </tr>
                <tr><th>MTR</th><td>{{ testResult.mtr }}</td></tr>
                <tr><th>Run id</th><td>{{ testResult.run_id }}</td></tr>
                <tr><th>Target</th><td>{{ testResult.target }}</td></tr>
                <tr v-if="testResult.branch"><th>Branch</th><td>{{ testResult.branch }}</td></tr>
                <tr v-if="testResult.repository"><th>Repository</th><td>{{ testResult.repository }}</td></tr>
                <tr v-if="testResult.commit_id"><th>Commit</th><td>{{ testResult.commit_id }}</td></tr>
                <tr><th>Test suite</th><td>{{ testResult.suite_name }}</td></tr>
                <tr><th>Date</th><td>{{ testResult.suite_timestamp }}</td></tr>
                <tr v-if="testResult.result_total_time"><th>Total time</th><td>{{ testResult.result_total_time }}</td></tr>
                <tr v-if="testResult.ci_service"><th>CI Service</th><td>{{ testResult.ci_service }}</td></tr>
                <tr v-if="testResult.filesystem"><th>Filesystem</th><td>{{ testResult.filesystem }}</td></tr>
                <tr v-if="testResult.logs_url">
                    <th>Logs</th>
                    <td><a :href="this.specifiedLogsUrl" target="_blank"> Open logs </a></td>
                </tr>
            </tbody>
        </table>
        <div class="test-result-message-container" v-if="testResult.message">
            <b-button class="copy-message-button"
                      icon-left="content-copy"
                      @click="copyMessage"
                      rounded
                      size="is-small"
                      type="is-dark"/>
            <pre class="test-result-message">{{ testResult.message }}</pre>
        </div>
    </div>
</template>

<script>
    import TestResult from "./TestResult";
    import EditField from "./EditField";
    import {MAXSCALE_MTR_NAME} from "@/utils/constants";

    export default {
        name: "TestResultContent",
        props: {
            testResult: Object,
            testCase: Object,
            onIssueUrlUpdate: Function,
        },
        computed: {
            specifiedLogsUrl() {
                if (this.testResult.mtr === MAXSCALE_MTR_NAME)
                    return `${this.testResult.logs_url}/LOGS/${this.testCase.name}`
                return this.testResult.logs_url;
            }
        },
        methods: {
            copyMessage() {
                this.$copyText(this.testResult.message)
                    .then(() => this.$buefy.toast.open('Message was copied'));
            },
            generateProductsTargetsArray(productsTargetsString) {
              if (productsTargetsString === undefined)
                return []

              return productsTargetsString.split(";")
            },
        },
        components: {
            TestResult,
            EditField,
        }
    }
</script>

<style lang="scss">
    .test-result-message-container {
        position: relative;
    }

    .copy-message-button {
        position: absolute;
        top: 1em;
        right: 1em;
    }

    .test-result-content__subtitle {
        display: flex;
        align-items: center;
    }
</style>